import { Input } from 'msteams-ui-components-react';
import React from 'react';
import { WizardButton } from '../../Shared/Wizard';
import { useThemeContext, WizardContext } from '../../../context';
import { StyledLabel, WizardActions } from '../../Shared/Styled';
import './EnterTabName.scss';

export interface EnterTabNameProps {
  connectionName?: string;
  isPw365Project?: boolean;
  onTabNameChange: (tabName: string) => any;
  defaultValue: string;
  errorLabel?: string;
}

export function EnterTabName({
  onTabNameChange,
  defaultValue,
  errorLabel,
  connectionName,
  isPw365Project,
}: EnterTabNameProps): JSX.Element {
  const theme = useThemeContext();
  return (
    <WizardContext.Consumer>
      {({ prev, goto }) => (
        <div
          id='EnterTabName'
          style={{
            display: 'inline-flex',
            width: '100%',
            flexDirection: 'column',
          }}
        >
          <StyledLabel style={{ marginTop: '9px' }} themeStr={theme}>
            <span>Enter Tab Name</span>
          </StyledLabel>
          <TabNameInput
            defaultValue={defaultValue}
            onTabNameChange={onTabNameChange}
            errorLabel={errorLabel}
          />
          <WizardActions>
            <WizardButton
              direction='back'
              label={
                isPw365Project
                  ? 'Default Content'
                  : connectionName
                  ? 'Connection'
                  : 'Service'
              }
              onClick={
                isPw365Project ? () => goto('choose-default-route') : prev
              }
              theme={theme}
            />
          </WizardActions>
        </div>
      )}
    </WizardContext.Consumer>
  );
}

interface TabNameInputProps {
  defaultValue: string;
  onTabNameChange: (tabName: string) => any;
  errorLabel?: string;
}

function TabNameInput({
  defaultValue,
  onTabNameChange,
  errorLabel,
}: TabNameInputProps): JSX.Element {
  const theme = useThemeContext();

  return (
    <Input
      autoFocus
      type='text'
      name='enter-tab-name'
      onChange={e => onTabNameChange(e.target.value)}
      defaultValue={defaultValue}
      errorLabel={errorLabel}
      data-testid='tabNameInput'
      className={`etn-${theme}`}
      style={{
        fontSize: '14px',
      }}
    />
  );
}
